/**
 * Web Serial の SerialPort を診断ログ用の文字列にする。
 * getInfo() は仕様上ペアリング済みでない場合などに値を持たないことがあるため、
 * ログ出力で例外を出さないよう全てのケースを文字列に丸める。
 * @param {SerialPort} port 対象のポート。null/undefined も許容する。
 * @returns {string} `<usbVendorId>:<usbProductId>` 形式の文字列
 */
const describeSerialPort = function (port) {
    if (!port) {
        return 'none';
    }
    if (typeof port.getInfo !== 'function') {
        return 'unknown';
    }
    try {
        const info = port.getInfo();
        return `${info.usbVendorId}:${info.usbProductId}`;
    } catch (e) {
        return 'unknown';
    }
};

module.exports = describeSerialPort;
